export default class GetCategoriaByPerfilCursoAndId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPerfilCurso, idCategoria) {
    try {
      const result = await this.#repository.getCategoriaByPerfilCursoAndId(idPerfilCurso, idCategoria)
      return result
    } catch (error) {
      throw error
    }
  }
}
